var map = {
	"./ua-parser": 156,
	"./ua-parser.js": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 807;



//////////////////
// WEBPACK FOOTER
// ./~/_ua-parser-js@0.7.16@ua-parser-js/src ^\.\/.*$
// module id = 807
// module chunks = 0 1